import Invitation from "./invitation";
import { UserRole } from "./user_role";
import type { ModifyPartial } from "type_aliases";
import { ApiInvitation, ApiUserRole, UserRole as LegacyUserRole } from "avvir";
import { immerable } from "immer";

export type OrganizationMemberArgument = ModifyPartial<OrganizationMember, {
  invitations: Invitation[] | ApiInvitation[],
  userRoles: UserRole[] | ApiUserRole[],
}>;

export class OrganizationMember {
  id: number;
  name: string;
  email: string;
  legacyRole: LegacyUserRole;
  accountCreatedAt: number;
  accountAcceptedAt: number;
  invitations: Invitation[];
  userRoles: UserRole[];

  static readonly [immerable] = true;

  constructor({
    id,
    name,
    email,
    legacyRole,
    accountCreatedAt,
    accountAcceptedAt,
    invitations,
    userRoles
  }: Partial<OrganizationMemberArgument> = {})
  {
    this.id = id;
    this.name = name;
    this.email = email;
    this.legacyRole = legacyRole;
    this.accountCreatedAt = accountCreatedAt;
    this.accountAcceptedAt = accountAcceptedAt;
    this.invitations = invitations == null ? [] : invitations.map((invite) => new Invitation(invite));
    this.userRoles = userRoles == null ? [] : userRoles.map((role) => new UserRole(role));
  }
}
